import { makeAutoObservable, runInAction } from 'mobx'

import { serverMessage } from '@/Ship/Helpers/serverError'

import { LoadDiskAdminStorageTask } from '../Tasks/LoadDiskAdminStorageTask'
import { LoadDiskAdminTrendTask } from '../Tasks/LoadDiskAdminTrendTask'

import type { DiskAdminStorageCard, DiskAdminTrend } from '../Contracts/DiskAdmin'

/** Вікно міні-тренду картки. */
export const STORAGE_TREND_DAYS = 30

/** Картка простору (`DISK-006` §3.3): агрегати й міні-тренд простору. */
export class DiskAdminStorageStore {
    uuid: string | null = null
    card: DiskAdminStorageCard | null = null
    isLoading = false
    error: string | null = null
    trend: DiskAdminTrend | null = null

    private requestId = 0

    constructor() {
        makeAutoObservable<DiskAdminStorageStore, 'requestId'>(this, { requestId: false })
    }

    open(uuid: string): void {
        if (this.uuid !== uuid) {
            this.card = null
            this.trend = null
        }

        this.uuid = uuid
        void this.reload()
    }

    async reload(): Promise<void> {
        const uuid = this.uuid

        if (uuid === null) return

        const id = ++this.requestId

        this.isLoading = true
        this.error = null

        void LoadDiskAdminTrendTask(STORAGE_TREND_DAYS, uuid)
            .then((trend) =>
                runInAction(() => {
                    if (id === this.requestId) this.trend = trend
                })
            )
            .catch(() => undefined)

        try {
            const card = await LoadDiskAdminStorageTask(uuid)

            runInAction(() => {
                if (id === this.requestId) this.card = card
            })
        } catch (error) {
            runInAction(() => {
                if (id === this.requestId) this.error = serverMessage(error, 'Не вдалося відкрити диск')
            })
        } finally {
            runInAction(() => {
                if (id === this.requestId) this.isLoading = false
            })
        }
    }
}

export const diskAdminStorageStore = new DiskAdminStorageStore()
